import $ from 'jquery';
import { nanoid } from 'nanoid';
import { load } from 'recaptcha-v3';
import AirDatepicker from 'air-datepicker';
import localEn from 'air-datepicker/locale/en';
import { trapFocus, releaseFocus } from '../../common/js/modalA11y';

let attachedFiles = [];
let invalidFiles = [];
let overSizedFiles = [];

const formHandler = {
    variables: {
        age: null,
        minAge: null,
        maxAge: null,
        isValidAge: true,
        isValidIncome: true,
        name: null,
        firstName: null,
        email: null,
        dob: null,
        dobDatepicker: null,
        countryCode: null,
        mobileNo: null,
        servletID: null,
        annualIncome: null,
        pincode: null,
        financialYear: null,
        assessmentYear: null,
        quarter: null,
        city : null,
        leadId : null,
        productCategory : null,
        productName : null,
        allowUtmParam: null,
        isISNPRedirection: null,
        isCLPRedirection: null,
        doNotSendDataInParam: null,
        siteKey : '6LcW0h8qAAAAAO2QgLupJ0tglgpVbguVB3-IxXIp',
        countryCode: [
            { codeString: '+91', code: '+91' },
            { codeString: '+376', code: '+376' },
            { codeString: '+54', code: '+54' },
            { codeString: '+61', code: '+61' },
            { codeString: '+43', code: '+43' },
            { codeString: '+32', code: '+32' },
            { codeString: '+1441', code: '+1441' },
            { codeString: '+359', code: '+359' },
            { codeString: '+1', code: '+1' },
            { codeString: '+385', code: '+385' },
            { codeString: '+357', code: '+357' },
            { codeString: '+420', code: '+420' },
            { codeString: '+593', code: '+593' },
            { codeString: '+358', code: '+358' },
            { codeString: '+33', code: '+33' },
            { codeString: '+49', code: '+49' },
            { codeString: '+30', code: '+30' },
            { codeString: '+1671', code: '+1671' },
            { codeString: '+852', code: '+852' },
            { codeString: '+36', code: '+36' },
            { codeString: '+354', code: '+354' },
            { codeString: '+353', code: '+353' },
            { codeString: '+39', code: '+39' },
            { codeString: '+81', code: '+81' },
            { codeString: '+371', code: '+371' },
            { codeString: '+423', code: '+423' },
            { codeString: '+370', code: '+370' },
            { codeString: '+352', code: '+352' },
            { codeString: '+356', code: '+356' },
            { codeString: '+377', code: '+377' },
            { codeString: '+31', code: '+31' },
            { codeString: '+64', code: '+64' },
            { codeString: '+47', code: '+47' },
            { codeString: '+968', code: '+968' },
            { codeString: '+48', code: '+48' },
            { codeString: '+351', code: '+351' },
            { codeString: '+974', code: '+974' },
            { codeString: '+40', code: '+40' },
            { codeString: '+65', code: '+65' },
            { codeString: '+421', code: '+421' },
            { codeString: '+386', code: '+386' },
            { codeString: '+82', code: '+82' },
            { codeString: '+34', code: '+34' },
            { codeString: '+46', code: '+46' },
            { codeString: '+886', code: '+886' },
            { codeString: '+971', code: '+971' },
            { codeString: '+44', code: '+44' },
            { codeString: '+1', code: '+1' },
            { codeString: '+379', code: '+379' }
        ],
        transactionId: null,
        otpVerified: false,
    },
    methods: {
        IsoIntoDateTimeObject: function(str) {
            const date = new Date(str);
            const dateTimeObject = {
                year:   date.getFullYear(),
                month:  date.toLocaleDateString('en-US', {month: 'short'}),
                day:    date.getDate().toString().padStart(2, '0')
            }
            return dateTimeObject;
        },
        // The dob field displays dd/mm/yyyy to the user; the actual
        // yyyy-MM-dd value is kept in data-iso-value (set on date pick).
        // Use this instead of .val() wherever the real date is needed.
        getDobIso: function () {
            const dobInput = $('[name="dob"]');
            return dobInput.attr('data-iso-value') || dobInput.val();
        },
        // form.reset() clears the visible dd/mm/yyyy value but leaves
        // data-iso-value behind, so getDobIso() keeps returning the old
        // date and the next lookup goes out with a stale dob. Clear the
        // attribute, the picker and the derived age display together.
        clearDobField: function () {
            const dobInput = $('[name="dob"]');
            dobInput.removeAttr('data-iso-value').val('').removeClass('border-red-300');
            if (formHandler.variables.dobDatepicker) {
                formHandler.variables.dobDatepicker.clear({ silent: true });
            }
            formHandler.variables.dob = null;
            dobInput.closest('.generic-form__group').find('.generic-form__group--error').addClass('opacity-0');
            $('.generic-form__group--age').text('');
            $('.age-display').text('');
        },
        removeTextCenterFromTabs: function () {
            const tabParentContainer = $('.tabs__parent');
            const tabAlignment = tabParentContainer.find('.tabs-alignment').data('tabalignment');
            if(tabAlignment === 'left') {
                tabParentContainer.removeClass('text-center');
                const tabsContainer = $('.cmp-tabs');
                tabsContainer.removeClass('text-center');
                const alignTabs = $('.align__tabs-start');
                alignTabs.removeClass('justify-content-center').addClass('justify-content-start');
            } else {
                return;
            }
        },
        convertFormToJSON: (form) => {
            const array = $(form).serializeArray();
            const json = {};
            const isUtmSourceFromWebsiteSectionName = $(form).data('is-utm-source-from-website-section-name');
            $.each(array,(index, value) => {
                json[value.name] = value.value || "";
            });

            if (json["dob"]) {
                const isoDob = $(form).find('[name="dob"]').attr('data-iso-value');
                if (isoDob) {
                    json["dob"] = isoDob;
                }
            }

            const servletID = $(form).data('servlet-id');

            if(servletID == 'unclaimedAmount'){
                json["policyHolderName"] = json["name"];
                let date = json["dob"];
                date = formHandler.methods.IsoIntoDateTimeObject(date);
                json["dob"] = `${date.day}-${date.month}-${date.year.toString().slice(-2)}`;
            } else if(servletID == 'digital' || servletID == 'dst'){
                json["fullName"] = json["name"];
                delete json["name"];
                if(json["dob"]){
                    let date = json["dob"];
                    date = formHandler.methods.IsoIntoDateTimeObject(date);
                    json["dob"] = `${date.day}-${date.month}-${date.year}`;
                }else{
                    delete json["dob"];
                }
                json["mobileNumber"] = json["mobileNo"];
                delete json["mobileNo"];
                json["emailID"] = json["emaiID"];
                delete json["emaiID"];
                formHandler.variables.name = json["fullName"];
                formHandler.variables.firstName = json["firstName"];
                formHandler.variables.email = json["emailID"];
                formHandler.variables.dob = json["dob"];
                formHandler.variables.countryCode = json["countryCode"];
                formHandler.variables.mobileNo = json["mobileNumber"];
                formHandler.variables.servletID = "DST";
                formHandler.variables.annualIncome = json["annualIncome"];
                formHandler.variables.pincode = json["pincode"];
                formHandler.variables.productCategory = json["productCategory"];
                formHandler.variables.productName = json["productName"];
                formHandler.variables.city = json["city"];
                if (json["city"] && json["city"].toLowerCase() !== 'other') {
                    json["Website_Section_Name"] = "Website";
                }
            }
            //            if(servletID == 'digital'){
            //               formHandler.variables.servletID = "DIGITAL";
            //               json["isQualified"] = formHandler.variables.isValidAge && formHandler.variables.isValidIncome;
            //            }
            if(servletID == 'digital'){
                formHandler.variables.servletID = "DIGITAL";
                let maxAge = $('[name="dob"]').data('maxage');
                const date = formHandler.methods.getDobIso();
                if (maxAge !== undefined) {
                    const today = new Date();
                    const selectedDate = new Date(date);
                    const yearsDifference = today.getFullYear() - selectedDate.getFullYear();
                    const isBeforeBirthday = (
                        today.getMonth() < selectedDate.getMonth() ||
                        (today.getMonth() === selectedDate.getMonth() && today.getDate() < selectedDate.getDate())
                    );
                    const age = isBeforeBirthday ? yearsDifference - 1 : yearsDifference;
                    formHandler.variables.age = age;
                    formHandler.variables.maxAge = maxAge;
                    formHandler.variables.isValidAge = !(age > maxAge);
                }
                json["isQualified"] = formHandler.variables.isValidAge;
                formHandler.variables.allowUtmParam = json["allowUtmParam"];
                formHandler.variables.isISNPRedirection = json["isISNPRedirection"];
                formHandler.variables.isCLPRedirection = json["isCLPRedirection"] === true || json["isCLPRedirection"] === 'true';
                formHandler.variables.doNotSendDataInParam = form.closest('.generic-form').find('.generic-form__frame').data('doNotSendDataInParam');
            }
            if (servletID === 'tdsDownload') {
                const ayInput = $(form).find('[name="assessmentYear"]');
                if (ayInput.length && ayInput.attr('data-backend-value')) {
                    json.assessmentYear = ayInput.attr('data-backend-value');
                }
            }
            formHandler.methods.setUtmParametersInForm(json, isUtmSourceFromWebsiteSectionName);
            return json;
        },
        generateInputIds: function(){
            const inputs = $('.generic-form__input--id');
            inputs.each(function(){
                const id = nanoid();
                $(this).attr('id', id);
                $(this).siblings('.generic-form__group--label').attr('for', id);
                // $(this).siblings('.generic-form__group--label').attr('for', id);
            });
            // Name the consent checkbox from its visible label text (the
            // label has no "for", so clicking the text still does not toggle it).
            $('.generic-form__consent').each(function(){
                const label = $(this).find('.generic-form__consent--label');
                if (!label.length) { return; }
                const id = nanoid();
                label.attr('id', id);
                $(this).find('.generic-form__consent--input').attr('aria-labelledby', id);
            });
        },
        handleEmptyField: function(){
            const requiredInputs = $('.generic-form__group--input[required]');
            requiredInputs.each(function() {
                $(this).on('blur', function(){
                    if($(this).val() == ''){
                        $(this).addClass('border-red-300');
                        $(this).siblings('.empty-error').removeClass('opacity-0');
                    }
                });
            });
        },
        validateInput: function(){
            const inputs = $('.generic-form__group--input');
            const servletID = $($(inputs)[0]).closest('.generic-form').find('.generic-form__frame').data('servlet-id');
            const policyNum = $(".generic-form__group").find('[name="policyNum"]');
            const proposalNumber = $(".generic-form__group").find('[name="proposalNumber"]');

            if(servletID === 'haveQuestion'){
                const haveQuestionName = $('.generic-form__group--input[name="name"]');
                haveQuestionName.attr('data-regex', '^(?!.*[ .]{2})(?![ .])[a-zA-Z](?:[a-zA-Z .]{1,48})$');
            }

            function updateRegex() {
                const selectedRadio = $('input[type="radio"][name="application-radio"]:checked');
                if (selectedRadio.length === 0) return;

                const selectedId = selectedRadio.attr('id').toLowerCase();

                const applicationNumberInput = $('input[name="applicationNumber"]');
                applicationNumberInput.removeAttr('data-regex');

                policyNum.val("");
                proposalNumber.val("");

                let regexPattern = "";

                if (selectedId.includes("policy")) {
                    regexPattern = "^0\\d{9}$";
                    applicationNumberInput.val("");
                } else if (selectedId.includes("coi")) {
                    regexPattern = "^[A-Za-z0-9]+-[A-Za-z0-9]+$";
                    applicationNumberInput.val("");
                } else {
                    regexPattern = "^\\d{10}$";
                    applicationNumberInput.val("");
                }

                if (regexPattern) {
                    applicationNumberInput.attr('data-regex', regexPattern);
                }
            }

            $('input[type="radio"][name="application-radio"]').on('change', updateRegex);
            $(function () {
                function setCheckedRadio() {
                    const radioButtons = $('input[type="radio"][name="application-radio"]');

                    if (radioButtons.length) {
                        radioButtons.on('change', updateRegex);

                        const firstRadio = radioButtons.first();
                        firstRadio.prop("checked", true).trigger("change");
                    }
                }

                setCheckedRadio();
            });

            inputs.each(function () {
                $(this).on('input', function () {
                    const servletID = $($(inputs)[0]).closest('.generic-form').find('.generic-form__frame').data('servlet-id');
                    if(servletID === 'haveQuestion'){
                        const haveQuestionName = $('.generic-form__group--input[name="name"]');
                        haveQuestionName.attr('data-regex', '^(?!.*[ .]{2})(?![ .])[a-zA-Z](?:[a-zA-Z .]{1,48})$');
                    }

                    $(this).siblings('.empty-error').addClass('opacity-0');
                    $(this).removeClass('border-red-300');

                    let regexPattern = $(this).data('regex');

                    if ($(this).attr('name') === 'applicationNumber') {
                        regexPattern = $('input[name="applicationNumber"]').attr('data-regex');
                    }

                    const regex = regexPattern ? new RegExp(regexPattern) : null;

                    if (regex) {
                        if (regex.test($(this).val())) {
                            $(this).siblings('.invalid-error').addClass('opacity-0');
                            $(this).removeClass('border-red-300');
                            if ($(this).attr('type') == 'date') {
                                $(this).prev().removeClass('border-red-300');
                            }
                        } else {
                            if ($(this).hasClass('name') && (servletID != 'digital' && servletID != 'dst' && servletID != 'registerComplaint' && servletID != 'haveQuestion')) {
                                $(this).siblings('.invalid-error').addClass('opacity-0');
                                $(this).removeClass('border-red-300');
                            } else {
                                $(this).siblings('.invalid-error').removeClass('opacity-0');
                                $(this).addClass('border-red-300');
                            }
                        }
                    }

                    if ($(this).hasClass('mobile-padding')) {
                        const dropdown = $(this).closest('.generic-form__group').find(".generic-form__group--code-dropdown");
                        let cleaned = $(this).val().replace(/\D/g, '');
                        if (cleaned.length > 15) {
                            cleaned = cleaned.slice(0, 15);
                        }
                        $(this).val(cleaned);
                        if ($(dropdown).find('.country-code__option.selected').val() != +91) {
                            const regexForiegn = new RegExp($(this).data('regex-foriegn'));
                            if ($(this).val()) {
                                if (regexForiegn.test($(this).val())) {
                                    $(this).siblings('.invalid-error').addClass('opacity-0');
                                    $(this).removeClass('border-red-300');
                                } else {
                                    $(this).siblings('.invalid-error').removeClass('opacity-0');
                                    $(this).addClass('border-red-300');
                                }
                            }
                        }
                    }

                    if ($(this).hasClass('alternate-mobile-padding')) {
                        const dropdown = $(this).closest('.generic-form__group').find(".generic-form__group--code-dropdown");
                        let cleaned = $(this).val().replace(/\D/g, '');
                        if (cleaned.length > 15) {
                            cleaned = cleaned.slice(0, 15);
                        }
                        $(this).val(cleaned);
                        if ($(dropdown).find('.country-code__option.selected').val() != +91) {
                            const regexForiegn = new RegExp($(this).data('regex-foriegn'));
                            if ($(this).val()) {
                                if (regexForiegn.test($(this).val())) {
                                    $(this).siblings('.invalid-error').addClass('opacity-0');
                                    $(this).removeClass('border-red-300');
                                } else {
                                    $(this).siblings('.invalid-error').removeClass('opacity-0');
                                    $(this).addClass('border-red-300');
                                }
                            }
                        }
                    }

                    if ($(this).prop('required') && $(this).val() == '') {
                        if ($(this).attr('type') == 'date') {
                            $(this).prev().addClass('border-red-300');
                        }
                        $(this).addClass('border-red-300');
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).siblings('.empty-error').removeClass('opacity-0');
                    } else if ($(this).val() == '') {
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).removeClass('border-red-300');
                    }

                    const consentStatus = $('.generic-form__consent--input');
                    consentStatus.on('input',function(e){
                        $(this).addClass('border-blue-400').removeClass('border-red-300');
                        $(this).siblings('.generic-form__consent--error').addClass('opacity-0');
                        if($(this).prop('required') && !$(this).is(':checked')){
                            $(this).removeClass('border-blue-400').addClass('border-red-300');
                            $(this).siblings('.generic-form__consent--error').removeClass('opacity-0');
                        }
                    })
                    const fileInput = $('.file-attachment');
                    if(fileInput.length > 0){
                        fileInput.find('input').on('change',function(e){
                            function updateErrorPosition() {
                                const labelContainer = $('.file-attachment').find('.multiple__attachment-label--container');
                                const invalidErrorMessage = $('.file-attachment').find('.generic-form__group--fileError');

                                if (labelContainer.length > 0 && invalidErrorMessage.length > 0) {
                                    const labelHeight = labelContainer.outerHeight();
                                    invalidErrorMessage.attr('style', `top: ${labelHeight + 20}px !important;`);
                                }
                            }

                            if(invalidFiles.length > 0 || overSizedFiles.length > 0){
                                if(invalidFiles.length > 0){
                                    updateErrorPosition();
                                    $(this).siblings('.invalid-error').removeClass('opacity-0');
                                    $(this).siblings('.empty-error').addClass('opacity-0');
                                    $(this).siblings('.size-error').addClass('opacity-0');
                                    $(this).addClass('border-red-300');
                                }else if(overSizedFiles.length > 0){
                                    updateErrorPosition();
                                    $(this).siblings('.size-error').removeClass('opacity-0');
                                    $(this).siblings('.empty-error').addClass('opacity-0');
                                    $(this).siblings('.invalid-error').addClass('opacity-0');
                                    $(this).addClass('border-red-300');
                                }
                            }else{
                                $(this).siblings('.invalid-error').addClass('opacity-0');
                                $(this).siblings('.empty-error').addClass('opacity-0');
                                $(this).siblings('.size-error').addClass('opacity-0');
                                $(this).removeClass('border-red-300');
                            }
                        })
                    }
                })
            })
        },
        getApplicationStatus: function(response, form){
            const parentContainer = form.closest('.generic-form'),
                formsection = parentContainer.find('.generic-form__section'),
                responseContainer = parentContainer.find('.track-application'),
                name = parentContainer.find('.track-application__name'),
                dob = parentContainer.find('.track-application__date'),
                planName = parentContainer.find('.track-application__plan'),
                status = parentContainer.find('.track-application__status');
            name.text(response.name);
            dob.text(response.dob);
            planName.text(response.planName);
            status.text(response.status);
            responseContainer.removeClass('d-none');
            parentContainer.removeClass('d-none');
            formsection.addClass('d-none');
        },
        getUnclaimedAmount: function(response, form){
            const parentContainer = form.closest('.generic-form'),
                responseContainer = parentContainer.find('.unclaimed-amount'),
                rowsContainer = parentContainer.find('.unclaimed-amount__rows-container');

            // Clear any previously rendered rows
            rowsContainer.empty();

            // Normalise: handle array, wrapped object, or single object
            let entries;
            if (Array.isArray(response)) {
                entries = response;
            } else if (response && typeof response === 'object') {
                const arrayKey = Object.keys(response).find(k => Array.isArray(response[k]));
                entries = arrayKey ? response[arrayKey] : [response];
            } else {
                entries = [];
            }

            entries.forEach(function (entry) {
                const escaped = {
                    name: $('<span>').text(entry.PolicyholderName || '').html(),
                    policy: $('<span>').text(entry.PolicyNo || '').html(),
                    address: $('<span>').text(entry.Address || '').html(),
                    amount: $('<span>').text(entry.Amount || '').html()
                };
                const row = `
                    <div class="unclaimed-amount__row d-grid text-white">
                        <span class="unclaimed-amount__column--value font-body fw-bold">
                            ${escaped.name}
                        </span>
                        <span class="unclaimed-amount__column--value font-body fw-bold">
                            ${escaped.policy}
                        </span>
                        <span class="unclaimed-amount__column--value font-body fw-bold">
                            ${escaped.address}
                        </span>
                        <span class="unclaimed-amount__column--value font-body fw-bold">
                            ${escaped.amount}
                        </span>
                    </div>`;
                rowsContainer.append(row);
            });

            responseContainer.removeClass('d-none');
            formHandler.methods.resetFormFields();
        },
        postQuestions: function(response, form){
            formHandler.methods.resetFormFields();
            const parentContainer = form.closest('.generic-form'),
                responseContainer = parentContainer.find('.have-questions'),
                responseText = parentContainer.find('.have-questions__response');
            responseContainer.removeClass('d-none');
            $('body').addClass('overflow-hidden');
            $('body').append(responseContainer); // Move the loader to the body
            $(responseContainer).removeClass('d-none').addClass('inside-body-haveThankyou'); // Show the loader
            $('body').addClass('overflow-hidden');
            trapFocus($(responseContainer));
        },
        dstSubmission: function(form){
            formHandler.methods.resetFormFields();
            const parentContainer = form.closest('.generic-form');
            const dstResponseContainer = parentContainer.find('.dst-submission');
            $('body').append(dstResponseContainer); // Move the loader to the body
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-dstThankyou'); // Show the loader
            $('body').addClass('overflow-hidden');
            trapFocus($(dstResponseContainer));
        },
        digitalSubmission: function(form, clpRedirection){
            formHandler.methods.resetFormFields();
            const parentContainer = form.closest('.generic-form');
            const digitalResponseContainer = parentContainer.find('.digital-submission');
            if(clpRedirection){
                digitalResponseContainer.find('.digital-submission__close--icon').addClass('d-none');
            }
            if (formHandler.variables.city && formHandler.variables.city.toLowerCase() !== 'other') {
                const thankyouTextContainer = $(digitalResponseContainer).find('.thankyou-text');
                let validCityMessage = parentContainer.attr('data-valid-city-message');
                const nameText = formHandler.variables.firstName || (formHandler.variables.name ? formHandler.variables.name?.split(' ')[0] : '');
                validCityMessage = validCityMessage.replace('${customerName}', nameText);
                thankyouTextContainer.html(validCityMessage);
            } else if (formHandler.variables.city && formHandler.variables.city.toLowerCase() === 'other') {
                const thankyouTextContainer = $(digitalResponseContainer).find('.thankyou-text');
                let invalidCityMessage = parentContainer.attr('data-other-city-message');
                const nameText = formHandler.variables.firstName || (formHandler.variables.name ? formHandler.variables.name?.split(' ')[0] : '');
                invalidCityMessage = invalidCityMessage.replace('${customerName}', nameText);
                thankyouTextContainer.html(invalidCityMessage);
            }
            $('body').append(digitalResponseContainer); // Move the loader to the body
            if (!(window.location.pathname === '/' || window.location.pathname === '')) {
                $(digitalResponseContainer).removeClass('d-none').addClass('inside-body-dstThankyou'); // Show the loader
                $('body').addClass('overflow-hidden');
                trapFocus($(digitalResponseContainer));
            }
        },
        tdsSubmission: function (form, response) {
            formHandler.methods.resetFormFields();
            const parentContainer = form.closest('.generic-form');
            const tdsResponseContainer = parentContainer.find('.tds-submission');

            $('body').append(tdsResponseContainer);
            $(tdsResponseContainer).removeClass('d-none').addClass('inside-body-tdsThankyou');
            $('body').addClass('overflow-hidden');
            trapFocus($(tdsResponseContainer));

            setTimeout(() => {
                const descElement = tdsResponseContainer.find('*').filter(function () {
                    const html = $(this).html();
                    return html && html.indexOf('${EMAIL_PLACEHOLDER}') !== -1;
                }).first();

                if (descElement.length) {
                    let maskedEmail = '';
                    if (response && response.mailTo) {
                        maskedEmail = formHandler.methods.maskEmail(response.mailTo);
                    }

                    const html = descElement.html();
                    const updatedHtml = html.replace(/\$\{EMAIL_PLACEHOLDER\}/g, maskedEmail);
                    descElement.html(updatedHtml);
                }

                const closeIcon = tdsResponseContainer.find('.tds-submission__close--icon');
                const redirectUrl = tdsResponseContainer.data('tds-redirect-url');

                closeIcon.off('click').on('click', function () {
                    $(tdsResponseContainer).addClass('d-none').removeClass('inside-body-tdsThankyou');
                    $('body').removeClass('overflow-hidden');
                    releaseFocus();

                    if (redirectUrl && redirectUrl.trim().length > 0) {
                        window.location.replace(redirectUrl);
                    } else {
                        location.reload();
                    }
                });
            }, 100);
        },
        maskEmail: function (email) {
            if (!email || !email.includes('@')) return email;
            const [user, domain] = email.split('@');
            const parts = user.split('.');
            const maskedParts = parts.map(part => {
                if (part.length <= 3) return '*'.repeat(part.length);
                const visible = Math.min(2, part.length - 1);
                const prefix = part.slice(0, visible);
                const suffix = part.slice(-1);
                const hidden = '*'.repeat(part.length - visible - 1);
                return prefix + hidden + suffix;
            });
            return maskedParts.join('.') + '@' + domain;
        },

        retailGroupSubmission: function(form){
            formHandler.methods.resetFormFields();
            const parentContainer = form.closest('.generic-form');
            const digitalResponseContainer = parentContainer.find('.retail-policy');
            $('body').append(digitalResponseContainer); // Move the loader to the body
            $(digitalResponseContainer).removeClass('d-none').addClass('inside-body-dstThankyou'); // Show the loader
            $('body').addClass('overflow-hidden');
            trapFocus($(digitalResponseContainer));
        },
        redirectionForm: function(response, form){
            let url = form.find('.generic-form--redirect').data('url');
            const target = form.find('.generic-form--redirect').attr('target') || '_self';
            $('.generic-form--redirect').attr('href', url);
            if(url){
                if(response.form && formHandler.variables.isValidAge && formHandler.variables.isValidIncome){
                    if(formHandler.methods.hasQueryParameters(url)){
                        formHandler.methods.resetFormFields();
                            if(formHandler.variables.isISNPRedirection){
                                url = url+"&data="+response.form;
                            } else {
                                url = url+"&form="+response.form;
                            }
                        url = formHandler.methods.appendUtmParam(url);
                        setTimeout(function() {
                            window.open(url, target);
                            formHandler.methods.handleLoader(loader, false);
                        }, 2000);
                    }else{
                        formHandler.methods.resetFormFields();
                            if(formHandler.variables.isISNPRedirection){
                                url = url+"?data="+response.form;
                            } else {
                                url = url+"?form="+response.form;
                            }
                        url = formHandler.methods.appendUtmParam(url);

                        setTimeout(function() {
                            window.open(url, target);
                            formHandler.methods.handleLoader(loader, false);
                        }, 2000);
                    }
                }
            }
        },

        appendUtmParam: function(url) {
            if(formHandler.variables.allowUtmParam) {
                const utmParams = [
                    'utm_medium',
                    'utm_source',
                    'utm_campaign',
                    'utm_content',
                    'utm_term',
                    'utm_cohort'
                ];
                const queryParts = utmParams
                    .map(param => {
                        const value = formHandler.methods.getQueryStringValue(param);
                        return value ? `${encodeURIComponent(param)}=${encodeURIComponent(value)}` : null;
                    })
                    .filter(Boolean);
                if (queryParts.length) {
                    const separator = url.includes('?') ? '&' : '?';
                    url = url + separator + queryParts.join('&');
                }
            }
            return url;
        },

        hasQueryParameters: function(url) {
            const parsedUrl = new URL(url);
            return parsedUrl.search.length > 0;
        },

        resetFormFields: function(){
            const form = document.querySelector('form.generic-form__frame');
            const linkIcon = $('.file-attachment').find('.link-icon');

            if (form) {
                form.reset();
                function enableInputFileds() {
                    $('input[name="name"], input[name="mobileNo"], input[name="alternateMobileNo"], input[name="emaiID"]').val('').prop('disabled', false);
                }
                enableInputFileds();

                const customFields = form.querySelectorAll('.generic-form__group--error');
                customFields.forEach(error => {
                    error.classList.add('opacity-0');
                });

                const dateInputs = $('.generic-form__group--input[name="dob"]');
                const ageContainer = dateInputs.siblings('.generic-form__group--age');
                ageContainer.text("");
                formHandler.methods.clearDobField();

                const fileInput = $('.file-attachment').find('input');
                fileInput.val('');

                attachedFiles = [];

                const labelContainer = $('.file-attachment').find('.file-place-1, .file-place-2, .file-place-3, .file-place-4, .file-place-5');

                labelContainer.each(function () {
                    $(this).hide();
                    $(this).find('span:first-child').text('');
                });

                linkIcon.show();
                fileInput.prop('disabled', false);

                const dropdowns = form.querySelectorAll('select');
                dropdowns.forEach(dropdown => {
                    dropdown.selectedIndex = 0;
                    let dropdownInputField = $(dropdown).closest('.generic-form__group--input');
                    if(dropdownInputField.hasClass('text-black-500')){
                        dropdownInputField.removeClass('text-black-500').addClass('text-black-300');
                    }
                });

                function updateRegex() {
                    const selectedRadio = $('input[type="radio"][name="application-radio"]:checked');
                    if (selectedRadio.length === 0) return;

                    const selectedId = selectedRadio.attr('id').toLowerCase();

                    const applicationNumberInput = $('input[name="applicationNumber"]');
                    applicationNumberInput.removeAttr('data-regex');

                    let regexPattern = "";

                    if (selectedId.includes("policy")) {
                        regexPattern = "^0\\d{9}$";
                        applicationNumberInput.val("");
                    } else if (selectedId.includes("coi")) {
                        regexPattern = "[A-Z0-9-]+$";
                        applicationNumberInput.val("");
                    } else {
                        regexPattern = "^\\d{10}$";
                        applicationNumberInput.val("");
                    }

                    if (regexPattern) {
                        applicationNumberInput.attr('data-regex', regexPattern);
                    }
                }

                $('input[type="radio"][name="application-radio"]').on('change', updateRegex);

                $(function () {
                    function setCheckedRadio() {
                        const radioButtons = $('input[type="radio"][name="application-radio"]');

                        if (radioButtons.length) {
                            radioButtons.on('change', updateRegex);

                            const firstRadio = radioButtons.first();
                            firstRadio.prop("checked", true).trigger("change");
                        } else {
                            setTimeout(setCheckedRadio, 100);
                        }
                    }

                    setCheckedRadio();
                });
            }
        },
        setUtmParametersInForm: function(json, isUtmSourceFromWebsiteSectionName) {

            let utm_medium = formHandler.methods.getQueryStringValue('utm_medium');
            let utm_source = formHandler.methods.getQueryStringValue('utm_source');
            let utm_campaign = formHandler.methods.getQueryStringValue('utm_campaign');
            let utm_content = formHandler.methods.getQueryStringValue('utm_content');
            let utm_term = formHandler.methods.getQueryStringValue('utm_term');
            let utm_cohort = formHandler.methods.getQueryStringValue('utm_cohort');


            if (utm_medium != null) {
                json["utmMedium"] = utm_medium;
            }
            if (utm_source != null) {
                json["utmSource"] = utm_source;
            } else {
                if (isUtmSourceFromWebsiteSectionName) {
                    const websiteSectionName = json["Website_Section_Name"];
                    if (websiteSectionName) {
                        json["utmSource"] = websiteSectionName;
                    } else {
                        json["utmSource"] = "Organic";
                    }
                } else {
                    json["utmSource"] = "Organic";
                }

            }
            if (utm_campaign != null) {
                json["utmCampaign"] = utm_campaign;
            }
            if (utm_content != null) {
                json["utmContent"] = utm_content;
            }
            if (utm_term != null) {
                json["utmTerm"] = utm_term;
            }
            if (utm_cohort != null) {
                json["utmCohort"] = utm_cohort;
            }
            return json;
        },

        getQueryStringValue: function(key) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has(key)) {
                return urlParams.get(key);
            } else {
                return null;
            }
        },

        closeResponse: function(ele){
            const closeContainer = $('.generic-form .have-questions__close');
            closeContainer.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.have-questions').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-haveThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-haveThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
        },
        closeHaveQuestionResponse: function(ele){
            const closeContainer = $('.have-questions__container .have-question__close--icon');
            closeContainer.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.have-questions').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-haveThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-haveThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
        },
        closeDSTResponse: function(ele){
            const closeIcon = $('.generic-form .have-question__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.have-questions').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-haveThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-haveThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
        },
        closeDigitalResponse: function(ele){
            const closeIcon = $('.generic-form .have-question__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.have-questions').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-haveThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-haveThankyou').addClass('d-none'));
                    releaseFocus();
                    if (closeIcon.closest('.digital-submission').hasClass('city-submission')) {
                        window.location.href = window.location.origin;
                    }
                });
            });
        },
        closeDSTResponse: function(ele){
            const closeContainer = $('.generic-form .dst-submission__close');
            closeContainer.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.dst-submission').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-dstThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-dstThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
            const closeIcon = $('.generic-form .dst-submission__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.dst-submission').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-dstThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-dstThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
        },
        closeDigitalResponse: function(ele){
            const closeContainer = $('.generic-form .digital-submission__close');
            closeContainer.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.digital-submission').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-dstThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-dstThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
            const closeIcon = $('.generic-form .digital-submission__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.digital-submission').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-dstThankyou');
                    $(ele).append($(loaderBody).removeClass('inside-body-dstThankyou').addClass('d-none'));
                    releaseFocus();
                });
            });
        },
        closeRetailGroupResponse: function(ele){
            // Dismissing this modal means "start the lookup over", so drop the
            // dob the failed attempt left behind. Otherwise the next blur on
            // the application number re-fires checkAndSendRequest with the old
            // date and the same error modal comes straight back.
            function dismiss(trigger){
                $(trigger).closest('.retail-policy').addClass('d-none');
                $('body').removeClass('overflow-hidden');
                $('body').css('overflow', ''); // Restore body scrolling
                const loaderBody = $('body').find('.inside-body-dstThankyou');
                $(ele).append($(loaderBody).removeClass('inside-body-dstThankyou').addClass('d-none'));
                formHandler.methods.clearDobField();
                $('input[name="applicationNumber"]').val('').removeClass('border-red-300');
                releaseFocus();
            }

            const closeContainer = $('.generic-form .retail-policy__close');
            closeContainer.each(function(){
                $(this).on('click', function(){
                    dismiss(this);
                });
            });
            const closeIcon = $('.generic-form .retail-policy__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    dismiss(this);
                });
            });
        },
        closeRequestComplaint : function(ele){
            const closeIcon = $(ele).find('.register__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    $(this).closest('.register').addClass('d-none');
                    $('body').removeClass('overflow-hidden');
                    $('body').css('overflow', ''); // Restore body scrolling
                    const loaderBody = $('body').find('.inside-body-register-complaint');
                    $(ele).append($(loaderBody).removeClass('inside-body-register-complaint').addClass('d-none'));
                    // Leave the user on a clean, usable form: make sure nothing is
                    // still hidden from the submit, and clear what they typed.
                    $(ele).removeClass('d-none');
                    $(ele).find('.generic-form__section, .generic-form__terms, .generic-form__frame').removeClass('d-none');
                    formHandler.methods.resetFormFields();
                    releaseFocus();
                });
            });
        },
        customizeSelectField: function(){
            const select = $('.generic-form__select');
            select.each(function(){
                $(this).on('change', function(){
                    $(this).removeClass('text-black-300').addClass('text-black-500');
                });
            });
        },
        backToForm: function(){
            const backBtn = $('.generic-form__back');
            backBtn.each(function(){
                $(this).on('click', () => {
                    $(this).closest('.generic-form').find('.track-application').addClass('d-none');
                    $(this).closest('.generic-form').find('.unclaimed-amount').addClass('d-none');
                    $(this).closest('.generic-form').find('.generic-form__section').removeClass('d-none');
                    $(this).closest('.generic-form').find('.generic-form__terms').removeClass('d-none');
                    $(this).closest('.generic-form').find('.form-error').addClass('d-none');
                });
            });
        },
        calculateAge: function(){
            const dateInputs = $('.generic-form__group--input[name="dob"]');
            dateInputs.each(function() {
                $(this).on('change', function() {
                    let age = new Date().getFullYear() - new Date($(this).val()).getFullYear();
                    //                    let minAge = dateInputs.data('minage');
                    let maxAge = dateInputs.data('maxage');
                    const monthDifference = new Date().getMonth() - new Date($(this).val()).getMonth(),
                        dayDifference = new Date().getDate() - new Date($(this).val()).getDate();
                    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
                        age--;
                    }
                    formHandler.variables.age = age;
                    //                    formHandler.variables.minAge = minAge;
                    formHandler.variables.maxAge = maxAge;
                    const ageContainer = $(this).siblings('.generic-form__group--age');
                    //                    if((age != null && age != undefined && minAge != null && minAge != undefined && maxAge != null && maxAge != undefined)
                    //                      && (age<minAge || age>maxAge)){
                    //                        formHandler.variables.isValidAge = false;
                    //                    }else{
                    //                        formHandler.variables.isValidAge = true;
                    //                    }
                    if((age != null && age != undefined && maxAge != null && maxAge != undefined)
                        && (age>maxAge)){
                        formHandler.variables.isValidAge = false;
                    }else{
                        formHandler.variables.isValidAge = true;
                    }
                    $(this).removeClass('border-red-300').addClass('border-transparent');
                    $(this).siblings('.invalid-error').addClass('opacity-0');
                    ageContainer.addClass('text-blue-400').removeClass('text-red-300');

                    const ageText = age + " " + ageContainer.data('suffix');
                    if(age || age==0){
                        ageContainer.text(ageText);
                    }
                    else{
                        ageContainer.text("");
                    }
                });
            });
        },
        //        checkAnnualIncome: function(){
        //               const annualIncomeInputs = $('.generic-form__group--input[name="annualIncome"]');
        //                  annualIncomeInputs.each(function() {
        //                     $(this).on('change',function() {
        //                       let annualIncome = $(this).val();
        //                       let minAnnualIncome = annualIncomeInputs.data("minincome");
        //                       if(parseInt(annualIncome, 10) < minAnnualIncome){
        //                         formHandler.variables.isValidIncome = false;
        //                       }else{
        //                          formHandler.variables.isValidIncome = true;
        //                       }
        //                       annualIncomeInputs.addClass('text-blue-400').removeClass('text-red-300');
        //                     });
        //                   });
        //        },

        verifyAfterSubmit: function(){
            const dateInputs = $('.generic-form__group--input[name="dob"]');
            let ageCheck = true;
            let incomeCheck = true;
            let age = new Date().getFullYear() - new Date(dateInputs.val()).getFullYear();
            //                    let minAge = dateInputs.data('minage');
            let maxAge = dateInputs.data('maxage');
            const monthDifference = new Date().getMonth() - new Date(dateInputs.val()).getMonth(),
                dayDifference = new Date().getDate() - new Date(dateInputs.val()).getDate();
            if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
                age--;
            }
            formHandler.variables.age = age;
            //                    formHandler.variables.minAge = minAge;
            formHandler.variables.maxAge = maxAge;
            const ageContainer = dateInputs.siblings('.generic-form__group--age');
            //                    if(((age || age ==0) && minAge && maxAge) && age<minAge || age>maxAge){
            //                    dateInputs.addClass('border-red-300').removeClass('border-transparent');
            //                    dateInputs.siblings('.invalid-error').removeClass('opacity-0');
            //                    ageContainer.removeClass('text-blue-400').addClass('text-red-300');
            //                    ageCheck = false;
            //                    }else{
            //                     dateInputs.removeClass('border-red-300').addClass('border-transparent');
            //                     dateInputs.siblings('.invalid-error').addClass('opacity-0');
            //                     ageContainer.addClass('text-blue-400').removeClass('text-red-300');
            //                   }
            if(((age || age ==0) && maxAge) && age>maxAge){
                dateInputs.addClass('border-red-300').removeClass('border-transparent');
                dateInputs.siblings('.invalid-error').removeClass('opacity-0');
                ageContainer.removeClass('text-blue-400').addClass('text-red-300');
                ageCheck = false;
            }else{
                dateInputs.removeClass('border-red-300').addClass('border-transparent');
                dateInputs.siblings('.invalid-error').addClass('opacity-0');
                ageContainer.addClass('text-blue-400').removeClass('text-red-300');
            }
            const ageText = age + " " + ageContainer.data('suffix');
            if(age){
                ageContainer.text(ageText);
            }
            else{
                ageContainer.text("");
            }

            //                   const annualIncomeInputs = $('.generic-form__group--input[name="annualIncome"]');
            //                   let annualIncome = annualIncomeInputs.val();
            //                   let minAnnualIncome = annualIncomeInputs.data("minincome");
            //                   if(parseInt(annualIncome, 10)  < minAnnualIncome){
            //                     annualIncomeInputs.addClass('border-red-300').removeClass('border-transparent');
            //                     annualIncomeInputs.siblings('.invalid-error').removeClass('opacity-0');
            //                     annualIncomeInputs.removeClass('text-blue-400').addClass('text-red-300');
            //                     incomeCheck = false;
            //                   }else{
            //                    annualIncomeInputs.removeClass('border-red-300').addClass('border-transparent');
            //                    annualIncomeInputs.siblings('.invalid-error').addClass('opacity-0');
            //                    annualIncomeInputs.addClass('text-blue-400').removeClass('text-red-300');
            //                   }
            //            return ageCheck && incomeCheck;
            return ageCheck;
        },
        handleFYAYAutoFill: function () {
            const fyDropdown = $('.generic-form__group--input[name="financialYear"]');
            const ayInput = $('.generic-form__group--input[name="assessmentYear"]');

            if (fyDropdown.length && ayInput.length) {
                fyDropdown.on('change', function () {
                    const fyValue = $(this).val(); // e.g. "2023-24" or "2023-2024"
                    if (fyValue) {
                        const years = fyValue.split('-');
                        if (years.length === 2) {
                            let startYear = parseInt(years[0]);
                            let endYear = parseInt(years[1]);

                            // Handle 2-digit year format (e.g., "25" -> "2025")
                            if (endYear < 100) {
                                const century = Math.floor(startYear / 100) * 100;
                                endYear = century + endYear;
                            }

                            const ayStart = endYear;
                            const ayEnd = ayStart + 1;

                            // Display full format on frontend: 2024-2025
                            const displayAY = `${ayStart}-${ayEnd}`;
                            ayInput.val(displayAY);

                            // Store short format for backend: 2024-25
                            const backendAY = `${ayStart}-${ayEnd.toString().slice(-2)}`;
                            ayInput.attr('data-backend-value', backendAY);

                            ayInput.removeClass('text-black-300').addClass('text-black-500');
                        }
                    } else {
                        ayInput.val('').removeClass('text-black-500').addClass('text-black-300');
                        ayInput.removeAttr('data-backend-value');
                    }
                });
            }
        },

        handleSubmit: function () {
            const forms = $('.generic-form__frame');
            forms.each(function () {
                // R4 home-page banner lead form (data-banner-lead="true"):
                // dedicated, isolated submit flow — returns before the OTP /
                // non-OTP handlers so this variant never runs OTP.
                //  - Name & Mobile both empty -> no consent, no API, straight
                //    redirect to the buying journey.
                //  - Either field filled -> consent is mandatory, then the lead
                //    API is called fire-and-forget: redirect on success OR
                //    failure, never surface an error. reCAPTCHA is kept.
                if ($(this).attr('data-banner-lead') === 'true') {
                    $(this).on('submit', function (e) {
                        e.preventDefault();
                        const $form = $(this);
                        const nameVal = ($form.find('[name="name"]').val() || '').trim();
                        const mobileVal = ($form.find('[name="mobileNo"]').val() || '').trim();
                        const consentCheckbox = $form.find('.generic-form__consent--input');
                        const consentError = $form.find('.generic-form__consent--error');
                        const redirectEl = $form.find('.generic-form--redirect');
                        const redirectUrl = redirectEl.data('url');
                        const openNewTab = redirectEl.attr('data-target') === 'true' || redirectEl.attr('target') === '_blank';
                        const goToJourney = () => {
                            if (!redirectUrl) { return; }
                            if (openNewTab) { window.open(redirectUrl, '_blank'); }
                            else { window.location.href = redirectUrl; }
                        };
                        if (nameVal === '' && mobileVal === '') {
                            goToJourney();
                            return;
                        }
                        if (consentCheckbox.length && !consentCheckbox.is(':checked')) {
                            consentCheckbox.siblings('.generic-form__consent--checkbox')
                                .removeClass('border-blue-400').addClass('border-red-300');
                            consentError.removeClass('opacity-0');
                            return;
                        }
                        let hasError = false;
                        $form.find('.generic-form__input--id').each(function () {
                            if ($(this).hasClass('border-red-300')) { hasError = true; }
                        });
                        if (hasError) { return; }
                        const recpatchaText = $form.data('recaptcha');
                        const servletID = $form.data('servlet-id');
                        const apiUrl = `/bin/chli/genericForm?servletID=${servletID}`;
                        load(formHandler.variables.siteKey).then((recaptcha) => {
                            recaptcha.execute('submit').then((token) => {
                                let json = formHandler.methods.convertFormToJSON($form);
                                if (typeof json === 'string') { json = JSON.parse(json); }
                                if (recpatchaText) { json['g-recaptcha-response'] = token; }
                                json['isOtpEnabled'] = false;
                                json['countryCode'] = $form.find('.country-code__option.selected').val();
                                json['leadConsent'] = consentCheckbox.is(':checked') ? 'Yes' : 'No';
                                json['gaId'] = getClientId();
                                formHandler.variables.name = nameVal;
                                formHandler.variables.mobileNo = mobileVal;
                                formHandler.variables.servletID = servletID ? servletID.toUpperCase() : '';
                                $.ajax({
                                    url: apiUrl,
                                    method: 'POST',
                                    contentType: 'application/json',
                                    data: JSON.stringify(json)
                                }).done((response) => {
                                    formHandler.variables.leadId = response && response.leadId ? response.leadId : '';
                                    let title = null;
                                    const titleEl = $form.closest('.generic-form').find('.generic-form__content h2, .generic-form__content h3').first();
                                    if (titleEl.length) { title = titleEl.text().trim(); }
                                    const buttonText = $form.find('.generic-form__submit .generic-form__submit--text').text().replace(/\s+/g, ' ').trim();
                                    const obj = formHandler.methods.dataLayerObj(buttonText, title, '');
                                    createDataLayer('LeadSubmitted', obj);
                                }).always(goToJourney);
                            }).catch(goToJourney);
                        }).catch(goToJourney);
                    });
                    return;
                }
                if ($(this).attr('data-is-otp-enabled') == 'true') {
                    $(this).on('submit', async function (e) {
                        e.preventDefault();
                        const loader = $(this).closest('.generic-form'),
                            formContainer = $(this).closest('.generic-form').find('.generic-form__section'),
                            termsContainer = $(this).closest('.generic-form').find('.generic-form__terms'),
                            consentCheckbox = $(this).find('.generic-form__consent--input'),
                            consentError = $(this).find('.generic-form__consent--error'),
                            selectDropdown = $(this).find('.generic-form__select'),
                            recpatchaText = $(this).data('recaptcha');
                        let isFormValid = true;
                        const inputs = $(this).find('.generic-form__input--id');
                        inputs.each(function () {
                            if ($(this).hasClass('border-red-300')) {
                                isFormValid = false;
                                return;
                            } else if ($(this).prop('required') && $(this).val() == "") {
                                isFormValid = false;
                                if ($(this).attr('type') == 'date') {
                                    $(this).prev().addClass('border-red-300');
                                }
                                $(this).addClass('border-red-300');
                                $(this).siblings('.empty-error').removeClass('opacity-0');
                                return;
                            }
                        });
                        if (consentCheckbox.prop('required') && !consentCheckbox.is(':checked')) {
                            isFormValid = false;
                            consentCheckbox.siblings('.generic-form__consent--checkbox').removeClass('border-blue-400').addClass('border-red-300');
                            consentError.removeClass('opacity-0');
                        }
                        selectDropdown.each(function () {
                            const $dropdown = $(this);

                            if ($dropdown.prop('required')) {
                                if (!$dropdown.val()) {
                                    isFormValid = false;
                                    $dropdown.removeClass('border-transparent').addClass('border-red-300');
                                    $dropdown.siblings('.empty-error').removeClass('opacity-0');
                                } else {
                                    $dropdown.addClass('border-transparent').removeClass('border-red-300');
                                    $dropdown.siblings('.empty-error').addClass('opacity-0');
                                }
                            }
                        });
                        if (isFormValid) {
                            const servletID = $(this).data('servlet-id');
                            const url = `/bin/chli/genericForm?servletID=${servletID}`;
                            load(formHandler.variables.siteKey).then((recaptcha) => {
                                recaptcha.execute('submit').then((token) => {
                                    const recaptchaInput = $(this).find('.generic-form__recaptcha');
                                    let json = formHandler.methods.convertFormToJSON($(this));
                                    if (recpatchaText) {
                                        json["g-recaptcha-response"] = token;
                                    }
                                    json["countryCode"] = $(this).find('.country-code__option.selected').val();
                                    json['leadConsent'] = (consentCheckbox && consentCheckbox.is(':checked')) ? 'Yes' : 'No';
                                    json['gaId'] = getClientId();
                                    const fileInput = $(this).find('.file-attachment');
                                    if (fileInput.length > 0 && attachedFiles.length > 0) {
                                        const base64Promises = attachedFiles.map(fileData =>
                                            new Promise((resolve) => {
                                                formHandler.methods.handleBase64(fileData.fileObject, (base64String) => {
                                                    // resolve({ base64String }); 
                                                    resolve(base64String);
                                                });
                                            })
                                        );

                                        Promise.all(base64Promises).then(base64Files => {
                                            if (typeof json === 'string') {
                                                json = JSON.parse(json);
                                            }

                                            // json['fileAttachment'] = base64Files;
                                            json['fileAttachment'] = base64Files;
                                            json['isOtpEnabled'] = true;

                                            json = JSON.stringify(json);

                                            recaptchaInput.val(token);

                                            if (servletID !== "haveQuestion") {
                                                termsContainer.addClass('d-none');
                                            }

                                            // code for otp here
                                            $(this).addClass("d-none");
                                            $(this).closest('.generic-form').find('.otp-container').removeClass('d-none').find(".otp-mobile-number").text(formHandler.methods.maskMobile(formHandler.variables.mobileNo));

                                            //add current height of the component as min-height to avoid layout shift
                                            const currentHeight = $(this).closest('.genericForm').outerHeight();
                                            $(this).closest('.genericForm').css('min-height', currentHeight + 'px');

                                            formHandler.methods.generateOtp($(this).closest('.generic-form'));

                                            const submitOtpAndContinue = (form) => {
                                                formHandler.methods.handleOtpSubmit(form).then(otpVerified => {
                                                    if (otpVerified) {
                                                        formHandler.methods.handleLoader(loader, true, false);
                                                        formHandler.methods.handleRequest(loader, $(this), formContainer, termsContainer, url, json, servletID, true);
                                                    } else {
                                                        console.log("OTP verification failed");
                                                        // Re-attach handler for retry
                                                        submitOtpAndContinue(form);
                                                    }
                                                });
                                            };

                                            submitOtpAndContinue($(this).closest('.generic-form'));

                                        });
                                    }
                                    else {
                                        json['isOtpEnabled'] = true;
                                        json = JSON.stringify(json);
                                        const servletID = $(this).data('servlet-id');
                                        recaptchaInput.val(token);
                                        // loader.removeClass('d-none');
                                        if (servletID != "haveQuestion") {
                                            // formContainer.addClass('d-none');
                                            termsContainer.addClass('d-none');
                                        }
                                        //write code for otp here
                                        $(this).addClass("d-none");
                                        $(this).closest('.generic-form').find('.generic-form__main').addClass('d-none');
                                        $(this).closest('.generic-form').find('.otp-container').removeClass('d-none').find(".otp-mobile-number").text(`${formHandler.variables.countryCode} ${formHandler.methods.maskMobile(formHandler.variables.mobileNo)}`);

                                        //add current height of the component as min-height to avoid layout shift
                                        const currentHeight = $(this).closest('.genericForm').outerHeight();
                                        $(this).closest('.genericForm').css('min-height', currentHeight + 'px');

                                        formHandler.methods.generateOtp($(this).closest('.generic-form'));

                                        const submitOtpAndContinue = (form) => {
                                            formHandler.methods.handleOtpSubmit(form).then(otpVerified => {
                                                if (otpVerified) {
                                                    formHandler.methods.handleRequest(loader, $(this), formContainer, termsContainer, url, json, servletID, true);
                                                    // Data Layer Event for OTP Submission
                                                    let title = null;
                                                    let titleElement = $(this).closest('.generic-form').find('.generic-form__content').find('h2');
                                                    if (titleElement.length > 0) {
                                                        title = titleElement.text().trim();
                                                    } if (title == null) {
                                                        titleElement = $(this).closest('.generic-form').find('.generic-form__content').find('h3');
                                                        if (titleElement.length > 0) {
                                                            title = titleElement.text().trim();
                                                        }
                                                    }
                                                    if (title != null && title != '') {
                                                        title = title;
                                                    }

                                                    let obj = formHandler.methods.dataLayerObj("submit otp", title, "");
                                                    createDataLayer('OTPSubmission_Success', obj);
                                                } else {
                                                    console.log("OTP verification failed");
                                                    //otp failure data layer event
                                                    let title = null;
                                                    let titleElement = $(this).closest('.generic-form').find('.generic-form__content').find('h2');
                                                    if (titleElement.length > 0) {
                                                        title = titleElement.text().trim();
                                                    } if (title == null) {
                                                        titleElement = $(this).closest('.generic-form').find('.generic-form__content').find('h3');
                                                        if (titleElement.length > 0) {
                                                            title = titleElement.text().trim();
                                                        }
                                                    }
                                                    if (title != null && title != '') {
                                                        title = title;
                                                    }

                                                    let obj = formHandler.methods.dataLayerObj("submit otp", title, "");
                                                    createDataLayer('OTPSubmission_Failed', obj);

                                                    // Re-attach handler for retry
                                                    submitOtpAndContinue(form);
                                                }
                                            });
                                        };

                                        submitOtpAndContinue($(this).closest('.generic-form'));
                                    }
                                });
                            }).catch(err => {
                                formHandler.methods.handleLoader(loader, false);
                                console.log(err);
                            });
                        }
                    });
                } else {
                    // OTP not enabled
                    $(this).on('submit', async function (e) {
                        e.preventDefault();
                        const loader = $(this).closest('.generic-form'),
                            formContainer = $(this).closest('.generic-form').find('.generic-form__section'),
                            termsContainer = $(this).closest('.generic-form').find('.generic-form__terms'),
                            consentCheckbox = $(this).find('.generic-form__consent--input'),
                            consentError = $(this).find('.generic-form__consent--error'),
                            selectDropdown = $(this).find('.generic-form__select'),
                            recpatchaText = $(this).data('recaptcha');
                        let isFormValid = true;
                        const inputs = $(this).find('.generic-form__input--id');
                        inputs.each(function () {
                            if ($(this).hasClass('border-red-300')) {
                                isFormValid = false;
                                return;
                            } else if ($(this).prop('required') && $(this).val() == "") {
                                isFormValid = false;
                                if ($(this).attr('type') == 'date') {
                                    $(this).prev().addClass('border-red-300');
                                }
                                $(this).addClass('border-red-300');
                                $(this).siblings('.empty-error').removeClass('opacity-0');
                                return;
                            }
                        });
                        if (consentCheckbox.prop('required') && !consentCheckbox.is(':checked')) {
                            isFormValid = false;
                            consentCheckbox.siblings('.generic-form__consent--checkbox').removeClass('border-blue-400').addClass('border-red-300');
                            consentError.removeClass('opacity-0');
                        }
                        selectDropdown.each(function () {
                            const $dropdown = $(this);

                            if ($dropdown.prop('required')) {
                                if (!$dropdown.val()) {
                                    isFormValid = false;
                                    $dropdown.removeClass('border-transparent').addClass('border-red-300');
                                    $dropdown.siblings('.empty-error').removeClass('opacity-0');
                                } else {
                                    $dropdown.addClass('border-transparent').removeClass('border-red-300');
                                    $dropdown.siblings('.empty-error').addClass('opacity-0');
                                }
                            }
                        });
                        if (isFormValid) {
                            formHandler.methods.handleLoader(loader, true);
                            const servletID = $(this).data('servlet-id');
                            const url = `/bin/chli/genericForm?servletID=${servletID}`;
                            load(formHandler.variables.siteKey).then((recaptcha) => {
                                recaptcha.execute('submit').then((token) => {
                                    const recaptchaInput = $(this).find('.generic-form__recaptcha');
                                    let json = formHandler.methods.convertFormToJSON($(this));
                                    if (recpatchaText) {
                                        json["g-recaptcha-response"] = token;
                                    }
                                    json['isOtpEnabled'] = false;
                                    json["countryCode"] = $(this).find('.country-code__option.selected').val();
                                    json['leadConsent'] = (consentCheckbox && consentCheckbox.is(':checked')) ? 'Yes' : 'No';
                                    json['gaId'] = getClientId();
                                    const fileInput = $(this).find('.file-attachment');
                                    if (fileInput.length > 0 && attachedFiles.length > 0) {
                                        const base64Promises = attachedFiles.map(fileData =>
                                            new Promise((resolve) => {
                                                formHandler.methods.handleBase64(fileData.fileObject, (base64String) => {
                                                    // resolve({ base64String }); 
                                                    resolve(base64String);
                                                });
                                            })
                                        );

                                        Promise.all(base64Promises).then(base64Files => {
                                            if (typeof json === 'string') {
                                                json = JSON.parse(json);
                                            }

                                            // json['fileAttachment'] = base64Files;
                                            json['fileAttachment'] = base64Files;

                                            json = JSON.stringify(json);

                                            recaptchaInput.val(token);

                                            if (servletID !== "haveQuestion") {
                                                termsContainer.addClass('d-none');
                                            }

                                            formHandler.methods.handleRequest(loader, $(this), formContainer, termsContainer, url, json, servletID);
                                        });
                                    }
                                    else {
                                        json = JSON.stringify(json);
                                        const servletID = $(this).data('servlet-id');
                                        recaptchaInput.val(token);
                                        // loader.removeClass('d-none');
                                        if (servletID != "haveQuestion") {
                                            // formContainer.addClass('d-none');
                                            termsContainer.addClass('d-none');
                                        }
                                        formHandler.methods.handleRequest(loader, $(this), formContainer, termsContainer, url, json, servletID);
                                    }
                                });
                            }).catch(err => {
                                formHandler.methods.handleLoader(loader, false);
                                console.log(err);
                            });
                        }
                    });
                }
            });
        },
        handleEmptyDropdown: function () {
            const requiredDropdowns = $('.generic-form__select[required]');

            requiredDropdowns.each(function () {
                $(this).on('change', function () {
                    const $dropdown = $(this);

                    if (!$dropdown.val()) {
                        $dropdown.addClass('border-red-300');
                        $dropdown.siblings('.empty-error').removeClass('opacity-0');
                    } else {
                        $dropdown.removeClass('border-red-300').addClass('border-transparent');
                        $dropdown.siblings('.empty-error').addClass('opacity-0');
                    }
                });
            });
        },
        handleRequest: function (loader, form, formContainer, termsContainer, url, json, servletID, isOtpEnabled = false) {
            let registerTimeoutId;
            let isRegisterResHandled = false;

            if (servletID == "registerComplaint") {
                formHandler.methods.handleLoader(loader, true);

                registerTimeoutId = setTimeout(() => {
                    if (!isRegisterResHandled) {
                        isRegisterResHandled = true;
                        formHandler.methods.handleLoader(loader, false);
                        const formContainerWrapper = $('.generic-form');
                        formContainerWrapper.removeClass('d-none');
                        formContainer.removeClass('d-none');
                        termsContainer.removeClass('d-none');
                    }
                }, 180000);
            }

            $.ajax({
                type: "POST",
                url: url,
                data: json,
                contentType: "application/json",
                dataType: "json",
            }).done((response) => {
                if (isOtpEnabled) {
                    formHandler.methods.handleLoader(loader, false, false);
                } else {
                    formHandler.methods.handleLoader(loader, false);
                }
                if (servletID == "trackApplication") {
                    formHandler.methods.buttonClickHandler($(this), response);
                    formHandler.methods.getApplicationStatus(response, $(form));
                } else if (servletID == "unclaimedAmount") {
                    formHandler.methods.buttonClickHandler($(this), response);
                    formHandler.methods.getUnclaimedAmount(response, $(form));
                    const formContainerWrapper = $('.generic-form');
                    formContainerWrapper.removeClass('d-none');
                    const formContainer = $('.generic-form__section');
                    formContainer.addClass('d-none');
                }else if(servletID == "haveQuestion"){
                    const formContainerWrapper = $('.generic-form');
                    formContainerWrapper.removeClass('d-none');
                    const formContainer = $('.generic-form__section');
                    formContainer.removeClass('d-none');
                    formHandler.methods.buttonClickHandler($(this),response);
                    formHandler.methods.postQuestions(response, $(form));
                }
                else if(servletID == "digital"){
                    formHandler.methods.buttonClickHandler($(form),response);
                    formHandler.methods.handleLoader(loader, true);

                    const formContainerWrapper = $('.generic-form');
                    const anchorTag = document.querySelector('.generic-form--redirect');
                    const dataUrl = anchorTag?.getAttribute('data-url') || '';

                    if(formHandler.methods.verifyAfterSubmit() && dataUrl.length > 0 && dataUrl !== '#') {
                        if(formHandler.variables.isCLPRedirection) {
                            formHandler.methods.digitalSubmission($(form), true);
                        }
                        formHandler.methods.redirectionForm(response, $(form));
                    }else{
                        formHandler.methods.digitalSubmission($(form), false);
                        formHandler.methods.handleLoader(loader, false);

                    }

                    formContainer.removeClass('d-none');
                    formContainerWrapper.removeClass('d-none');
                    termsContainer.removeClass('d-none');

                    if(form.closest('.generic-form')?.attr('data-is-otp-enabled')=='true'){
                        // form.closest('.generic-form').find('.otp-container')?.addClass('d-none');
                        form.closest('.generic-form').find('.generic-form__frame')?.removeClass('d-none');
                    }
                }
                else if(servletID == "dst"){
                    formHandler.methods.buttonClickHandler($(form),response);
                    if(formHandler.methods.verifyAfterSubmit()){
                        formHandler.methods.dstSubmission($(form));
                    }
                    formContainer.removeClass('d-none');
                    termsContainer.removeClass('d-none');
                }else if(servletID == "registerComplaint"){
                    if (registerTimeoutId) {
                        clearTimeout(registerTimeoutId);
                    }

                    if (!isRegisterResHandled) {
                        isRegisterResHandled = true;
                        formHandler.methods.handleRequestComplaintModal(response, form);
                        const formContainerWrapper = $('.generic-form');
                        formContainerWrapper.removeClass('d-none');
                        // Keep the form visible behind the modal, same as digital/dst/tds
                        // and same as the timeout fallback above. Hiding it left the page
                        // blank behind the overlay and stayed blank after the modal closed.
                        formContainer.removeClass('d-none');
                        termsContainer.removeClass('d-none');
                    }
                } else if (servletID === 'tdsDownload') {
                    formHandler.methods.handleLoader(loader, false);

                    const formContainerWrapper = $('.generic-form');
                    const formContainer = $('.generic-form__section');
                    const termsContainer = $(form).closest('.generic-form').find('.generic-form__terms');

                    if (response.status === 'SUCCESS' && response.status_code === '200') {
                        formHandler.methods.tdsSubmission($(form), response);

                        // Keep form visible behind modal (like digital)
                        formContainer.removeClass('d-none');
                        formContainerWrapper.removeClass('d-none');
                        if (termsContainer.length) termsContainer.removeClass('d-none');
                    } else {
                        formHandler.methods.resetFormFields(form);
                        formHandler.methods.showErrorScreen(form);
                    }
                }
            }).catch((error) => {
                console.error(error);
                formHandler.methods.handleLoader(loader, false);
                formHandler.methods.resetFormFields();
                const formContainerWrapper = $('.generic-form');
                formContainerWrapper.removeClass('d-none');
                const formContainer = $('.generic-form__section');
                formContainer.addClass('d-none');
                const errorContainer = $(form).closest('.generic-form').find('.form-error');
                errorContainer.removeClass('d-none');
            });
        },
        showErrorScreen: function (form) {
            const formContainerWrapper = $(form).closest('.generic-form');
            const formContainer = formContainerWrapper.find('.generic-form__section');
            const errorContainer = formContainerWrapper.find('.form-error');
            formContainer.addClass('d-none');
            errorContainer.removeClass('d-none');
            formContainerWrapper.removeClass('d-none');
        },
        sendRetailPolicyRequest: function(applicationNumber, dob, loader) {
            const apiUrl = "/bin/chli/genericForm?servletID=retailPolicy";
            const genericForm = $('.generic-form__frame').closest('.generic-form');
            const formContainer = $('.generic-form').find('.generic-form__section');

            const requestData = {
                proposalNumber: applicationNumber,
                dob: dob
            };

            $.ajax({
                url: apiUrl,
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(requestData)
            }).done((response) => {
                function updateFields() {
                    let fieldsUpdated = 0;
                    const totalFields = 6;

                    function updateField(selector, value) {
                        const field = $(selector);
                        if (value) {
                            field.val(value).prop('readonly', true);
                            field.removeClass('border-red-300');
                            field.siblings('.empty-error').addClass('opacity-0');
                            field.siblings('.invalid-error').addClass('opacity-0');
                        } else {
                            field.prop('readonly', false);
                        }
                        fieldsUpdated++;

                        if (fieldsUpdated === totalFields) {
                            formHandler.methods.handleLoader(loader, false);
                            genericForm.removeClass('d-none');
                        }
                    }

                    updateField('input[name="name"]', response.policyHolderName);
                    updateField('input[name="mobileNo"]', response.mobile);
                    updateField('input[name="alternateMobileNo"]', response.alternateMobile);
                    updateField('input[name="emaiID"]', response.email);
                    updateField('input[name="proposalNumber"]', response.proposalNumber);
                    updateField('input[name="policyNum"]', response.policyNumber);
                }

                updateFields();

            }).catch((error) => {
                formHandler.methods.handleLoader(loader, false);
                genericForm.removeClass('d-none');
                formHandler.methods.retailGroupSubmission(formContainer);
                console.error("Error sending registerComplaint request:", error);
            });
        },
        sendGroupAsiaRequest: function(applicationNumber, dob, loader) {
            const apiUrl = "/bin/chli/genericForm?servletID=groupPolicy";
            const genericForm = $('.generic-form');
            const formContainer = $('.generic-form').find('.generic-form__section');
            function formatDate(inputDate) {
                return inputDate ? parseInt(inputDate.replace(/-/g, ''), 10) : null;
            }

            const requestData = {
                certificateOfInsuranceNumber: applicationNumber,
                dateOfBirth: formatDate(dob)
            };

            $.ajax({
                url: apiUrl,
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(requestData)
            }).done((response) => {
                function updateFields() {
                    let fieldsUpdated = 0;
                    const totalFields = 4;

                    function updateField(selector, value) {
                        const field = $(selector);
                        if (value) {
                            field.val(value).prop('readonly', true);
                            field.removeClass('border-red-300');
                            field.siblings('.empty-error').addClass('opacity-0');
                            field.siblings('.invalid-error').addClass('opacity-0');
                        } else {
                            field.prop('readonly', false);
                        }
                        fieldsUpdated++;

                        if (fieldsUpdated === totalFields) {

                            formHandler.methods.handleLoader(loader, false);
                            genericForm.removeClass('d-none');
                        }
                    }

                    updateField('input[name="name"]', response.clientName);
                    updateField('input[name="mobileNo"]', response.mobilePhoneNumber);
                    updateField('input[name="alternateMobileNo"]', response.alternatePhoneNumberHome);
                    updateField('input[name="emaiID"]', response.emailAddress);
                }

                updateFields();

            }).catch((error) => {
                formHandler.methods.handleLoader(loader, false);
                genericForm.removeClass('d-none');
                formHandler.methods.retailGroupSubmission(formContainer);
                console.error("Error sending registerComplaint request:", error);
            });
        },
        makeAPIRequestForRetialPolicyGroupAsia: function () {
            const applicationNumberInput = $('input[name="applicationNumber"]');
            const dobInput = $('input[name="dob"]');
            const radioButtons = $('input[name="application-radio"]');
            const parentContainer = $('.generic-form__frame');
            const loader = parentContainer.closest('.generic-form');

            function checkAndSendRequest() {
                const applicationNumber = applicationNumberInput.length ? applicationNumberInput.val().trim() : '';
                const dob = dobInput.length ? formHandler.methods.getDobIso().trim() : '';
                const selectedRadio = radioButtons.filter(':checked').length ? radioButtons.filter(':checked').attr('id').trim().toLowerCase() : '';

                if (applicationNumber && dob && selectedRadio && !applicationNumberInput.hasClass('border-red-300')) {
                    if (selectedRadio.includes('application') || selectedRadio.includes('policy')) {
                        formHandler.methods.handleLoader(loader, true);
                        formHandler.methods.sendRetailPolicyRequest(applicationNumber, dob, loader);
                    }
                    else if(selectedRadio.includes('coi')){
                        formHandler.methods.handleLoader(loader, true);
                        formHandler.methods.sendGroupAsiaRequest(applicationNumber, dob, loader);
                    }
                }
            }

            applicationNumberInput.on('blur', checkAndSendRequest);
            dobInput.on('change blur', checkAndSendRequest);
            radioButtons.on('change', checkAndSendRequest);
        },
        handleRequestComplaintModal : function(response, form){
            console.log("removing the overflow from body");
            formHandler.methods.resetFormFields();
            const parentContainer = form.closest('.generic-form');
            const dstResponseContainer = parentContainer.find('.register');
            if (response) {
                dstResponseContainer.find('.complaint-id').find('span').text(response.ticketNumber);
            }
            parentContainer.append(dstResponseContainer); // Move the loader to the body
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-register-complaint'); // Show the loader
            // $('body').addClass('overflow-hidden');
        },
        handleBase64 : async function(file, callback){
            const reader = new FileReader();
            reader.onload = function(event) {
                const base64String = event.target.result.split(',')[1]; // Extract only base64 part
                callback(base64String); // Pass base64 result to callback
            };
            reader.readAsDataURL(file); // Start reading file
        },
        handleLoader(loader, isAdd, hideForm=true){
            const parentLoad = $(loader).find('.spinning-loader');
            if(isAdd){
                $('body').append(parentLoad);
                $(parentLoad).removeClass('d-none').addClass('inside-body-loader'); // Show the loader
                $('body').css('overflow', 'hidden'); // Prevent body scrolling
            }else{
                if(hideForm){
                    $(loader).addClass('d-none'); // Hide the loader
                }
                $('body').css('overflow', ''); // Restore body scrolling
                const loaderBody = $('body').find('.inside-body-loader');
                $(loader).append($(loaderBody).removeClass('inside-body-loader').addClass('d-none'));
            }
        },
        buttonClickHandler: function (element,response) {
            let buttonText = element.find('.generic-form__submit .generic-form__submit--text').text().replace(/\s+/g, ' ').trim();
            formHandler.variables.leadId = response.leadId;
            let title = null;
            let container=element.closest('.tab__container');
            let tabActive=container.find('.tab__navigations--item.active-tab');
            let tabText=tabActive.text().replace(/\n/g, '').trim();
            let titleElement = element.closest('.generic-form__content').find('h2');
            if (titleElement.length > 0) {
                title = titleElement.text().trim();
            }if(title == null){
                titleElement = element.closest('.generic-form__content').find('h3');
                if(titleElement.length > 0){
                    title = titleElement.text().trim();
                }
            }
            if(title!=null && title != '')
                {
                title = title;
            }
            if(tabText==null){
                tabText="Tabs";
            }
            var obj = formHandler.methods.dataLayerObj(buttonText, title,tabText);
            createDataLayer('LeadSubmitted', obj);
        },

        ctaButtonClickHandler: function(){
            $('.generic-form__right .generic-form__right--content').on('click','.generic-form__right--cta',function(){
                let buttonText = $(this).text().replace(/\s+/g, ' ').trim();
                let container = $(this).closest('.generic-form__right');
                let titleText = container.find('.generic-form__right--content h2').text().trim();
                let obj = formHandler.methods.dataLayerObj(buttonText,titleText);
                createDataLayer('buttonClick',obj);
            });
        },
        addCountryDropdown: function () {
            $('.generic-form').each((idx, ele) => {
                const dropdowns = $(ele).find('.generic-form__group--code-dropdown');

                dropdowns.each((i, dropdown) => {
                    dropdown = $(dropdown);
                    const inputNumber = dropdown.closest('.generic-form__group').find('.generic-form__group--input');

                    formHandler.variables.countryCode.forEach((country) => {
                        dropdown.append(`<option class="country-code__option" value="${country.code}">${country.codeString}</option>`);
                    });

                    $(dropdown.find('.country-code__option')[0]).addClass('selected');

                    dropdown.on('change', function () {
                        dropdown.find('.country-code__option').removeClass('selected');
                        dropdown.find('.country-code__option').each(function () {
                            if ($(this).val() == dropdown.val()) {
                                $(this).addClass('selected');
                            }
                        });

                        const selectedCountryCode = dropdown.find('.country-code__option.selected').val();
                        let regexForiegn = selectedCountryCode != "+91" ? new RegExp(inputNumber.data('regex-foriegn')) : new RegExp(inputNumber.data('regex'));

                        if (inputNumber.val()) {
                            if (regexForiegn.test(inputNumber.val())) {
                                inputNumber.siblings('.invalid-error').addClass('opacity-0');
                                inputNumber.removeClass('border-red-300');
                            } else {
                                inputNumber.siblings('.invalid-error').removeClass('opacity-0');
                                inputNumber.addClass('border-red-300');
                            }
                        }
                    });
                });
            });
        },
        dataLayerObj: function (el,e,tabText) {
            var obj = {
                'articleName': "",
                'blogCategory': "",
                'blogPageCategory': "",
                'buttonText': el ? el : "",
                'pageSection': e ? e : "Form_".concat(tabText),
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption': "",
                'productCategory': formHandler.variables.productCategory ?? "",
                'productName': formHandler.variables.productName ?? "",
                'question': "",
                'source': "",
                'leadForm': formHandler.variables.servletID ? formHandler.variables.servletID : "",
                'name': formHandler.variables.name ? formHandler.variables.name : "",
                'email': formHandler.variables.email ? formHandler.variables.email : "",
                'dob': formHandler.variables.dob ? formHandler.variables.dob : "",
                'countryCode': formHandler.variables.countryCode ? formHandler.variables.countryCode : "",
                'mobileNumber': formHandler.variables.mobileNo ? formHandler.variables.mobileNo : "",
                'pincode' : formHandler.variables.pincode ? formHandler.variables.pincode : "",
                'city' : formHandler.variables.city ? formHandler.variables.city : "",
                'leadId' : formHandler.variables.leadId ? formHandler.variables.leadId : "",
                'searchTerm': "",
                'videoTitle': "",
                'annualIncome':formHandler.variables.annualIncome ? formHandler.variables.annualIncome:"",
                'bannerName': "",
            };
            return obj;
        },

        handleDateInput:function (){
            const dateInputEl = $('.generic-form__group--input[name="dob"]');
            const placeholderEl = dateInputEl.prev();
            placeholderEl.on('click',(e)=>{
                $(e.currentTarget).addClass('d-none');
            });
            const isIos = [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform) || /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if(isIos){
                if(window.innerWidth <= 768){
                    dateInputEl.parent().find('.generic-form__group--error').addClass('ios--mobile__variation');
                }
            }
        },
        handleFileHandler: function (ele) {
            const $file = $(ele).find('.file-attachment').find('input'),
                $labelContainer = $(ele).find('.file-attachment').find('.file-place-1, .file-place-2, .file-place-3, .file-place-4, .file-place-5'),
                maxFiles = 5;
            const linkIcon = $(ele).find('.file-attachment').find('.link-icon');
            const maxSizeInBytes = 4 * 1024 * 1024;
            const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf'];

            $file.on('change', function (event) {
                const files = Array.from(event.target.files);

                files.forEach(file => {
                    const fileId = new Date().getTime();

                    if (!allowedTypes.includes(file.type)) {
                        invalidFiles.push({ id: fileId, fileName: file.name, fileObject: file });
                    }

                    if (file.size > maxSizeInBytes) {
                        overSizedFiles.push({ id: fileId, fileName: file.name, fileObject: file });
                    }

                    if (attachedFiles.length < maxFiles) {
                        attachedFiles.push({ id: fileId, fileName: file.name, fileObject: file });

                        if (attachedFiles.length === maxFiles) {
                            linkIcon.hide();
                            $file.prop('disabled', true);
                        }
                    }
                });

                updateFileDisplay();
                $file.val('');
            });

            $labelContainer.on('click', '.remove', function (event) {
                const fileIdToRemove = $(this).data('file-id');

                attachedFiles = attachedFiles.filter(file => file.id !== fileIdToRemove);
                invalidFiles = invalidFiles.filter(file => file.id !== fileIdToRemove);
                overSizedFiles = overSizedFiles.filter(file => file.id !== fileIdToRemove);

                updateFileDisplay();
                const eventChange = new Event('change', { bubbles: true });
                $file[0].dispatchEvent(eventChange);

                if (attachedFiles.length < maxFiles) {
                    linkIcon.show();
                    $file.prop('disabled', false);
                }
            });

            function updateFileDisplay() {
                $labelContainer.each(function (index) {
                    const $span = $(this).find('span:first-child');
                    const $removeIcon = $(this).find('.remove');

                    if (attachedFiles[index]) {
                        const displayName = attachedFiles[index].fileName.length > 6
                            ? attachedFiles[index].fileName.substring(0, 6) + "..."
                            : attachedFiles[index].fileName;

                        $span.text(displayName);
                        $(this).show();
                        $removeIcon.show();
                        $removeIcon.data('file-id', attachedFiles[index].id);
                    } else {
                        $span.text('');
                        $(this).hide();
                    }
                });
            }

            $labelContainer.hide();
        },
        generateOtp: function ( formElement, isResendOtp = false) {
            formHandler.methods.handleLoader(formElement, true, false);
            formElement.closest('.genericForm').find('.otp-hidden').focus();
            const parentForm = formElement;
            const mobileVal = formHandler.variables.mobileNo || parentForm.find('input[name="mobileNo"]').val().trim() || parentForm.find('input[name="mobile"]').val().trim() || parentForm.find('.generic-form__group--input[name="mobileNo"]').val().trim();
            const otpContainer = parentForm.find('.otp-container')
            const payload = {
                mobileNo: mobileVal,
                templateId: '1107176337065693984',
                appCode: 'WEBSITE'
            };

            $.ajax({
                url: '/bin/chli/sendOtp',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(payload),
                async: true,
                timeout: 5000
            }).done((response) => {
                formHandler.methods.handleLoader(formElement, false, false);
                const resBody = response && response.data ? response.data : response;
                const status = resBody && (resBody.status || resBody.Status || resBody.statusCode);
                const message = resBody && (resBody.message || resBody.Message || resBody.msg);
                formHandler.variables.transactionId = resBody && (resBody.transactionId || resBody.transactionId);

                if(status==='Fail'){
                    const errorMessageContainer = otpContainer.find('.otp-error');
                    errorMessageContainer.removeClass('d-none').text(message || 'Failed to send OTP. Please try again later.');
                    otpContainer.find('.otp-send-success').addClass('d-none');
                    otpContainer.find('.otp-success').addClass('d-none').empty();

                }else if (status==='Success' || status==='SUCCESS'){
                    const successMessageContainer = otpContainer.find('.otp-send-success');
                    if(isResendOtp){
                        otpContainer.find('.otp-success').removeClass('d-none').text('OTP sent successfully');
                    }
                    successMessageContainer.removeClass('d-none');
                    const errorMessageContainer = otpContainer.find('.otp-error');
                    errorMessageContainer.addClass('d-none').text('');
                }

            }).fail((jqXHR, textStatus, err) => {
                const errorEl = parentForm.closest('.generic-form').find('.form-error, .otp-error');
                if (errorEl.length) {
                    errorEl.removeClass('d-none').text('Failed to send OTP. Please try again later.');
                } else {
                    alert('Failed to send OTP. Please try again later.');
                }
                formHandler.methods.handleLoader(formElement, false, false);
            }).always(() => {
                // scroll up the height of otp container on mobile devices
                if ($(window).width() <= 768) {
                    const targetScroll = Math.max(
                        0,
                        otpContainer.offset().top - ($(window).height() / 3)
                    );

                    window.scrollTo({
                        top: targetScroll,
                        behavior: 'auto'
                    });
                }
                //Data Layer Event for first step form submission/otp generation
                let title = null;
                let titleElement = formElement.find('.generic-form__content').find('h2');
                if (titleElement.length > 0) {
                    title = titleElement.text().trim();
                } if (title == null) {
                    titleElement = formElement.find('.generic-form__content').find('h3');
                    if (titleElement.length > 0) {
                        title = titleElement.text().trim();
                    }
                }
                if (title != null && title != '') {
                    title = title;
                }
                let buttonText = formElement.find('.generic-form__submit .generic-form__submit--text').text().replace(/\s+/g, ' ').trim();
                let obj = formHandler.methods.dataLayerObj(buttonText, title, null);
                createDataLayer('FirstStep_FormSubmit', obj);
            })
        },

        verifyOtp: function (otpValue, parentForm) {
            console.log('Verifying OTP...', otpValue);
            parentForm = parentForm || $('.generic-form');

            const transactionId = formHandler.variables.transactionId;

            const payload = {
                appCode: 'WEBSITE',
                transactionId: transactionId,
                OTP: otpValue
            };

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: '/bin/chli/verifyOtp',
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(payload),
                    timeout: 10000
                })
                    .done((response) => {
                        const resBody = response && response.data ? response.data : response;
                        const status = resBody && (resBody.status || resBody.Status || resBody.statusCode);
                        const message = resBody && (resBody.message || resBody.Message || resBody.msg);

                        const successEl = parentForm.find('.otp-success');
                        const errorEl = parentForm.find('.otp-error');

                        const isSuccess = (status === 'Success' || status === 'SUCCESS');

                        if (isSuccess) {
                            successEl.removeClass('d-none').text(message || 'OTP verified successfully');
                            errorEl.addClass('d-none').text('');
                            parentForm.data('otpVerified', true);


                            resolve(true);    // <-- success
                        } else {
                            errorEl.removeClass('d-none').text(message || 'Invalid OTP. Please try again.');
                            successEl.addClass('d-none').text('');
                            parentForm.data('otpVerified', false);
                            resolve(false);  // <-- failure (but not AJAX failure)
                        }
                    })
                    .fail(() => {
                        parentForm.find('.otp-error')
                            .removeClass('d-none')
                            .text('Failed to verify OTP. Please try again later.');

                        parentForm.data('otpVerified', false);
                        resolve(false);      // Treat failure as "not verified"
                    })
                    .always(() => {
                        parentForm.find('.otp-box input').val('');
                        formHandler.variables.otpSubmitted = true;
                    });
            });
        },

        handleResendOtp: function () {
            const resendOtpButton = $('.resend-otp button');
            resendOtpButton.each((idx, ele) => {
                const $ele = $(ele);
                $ele.off('click').on('click', (e) => {
                    e.preventDefault();

                    // Check if already disabled
                    if ($ele.prop('disabled')) {
                        return;
                    }

                    console.log('Resending OTP...');
                    formHandler.methods.generateOtp( $ele.closest('.generic-form'), true);

                    // Disable button and start 30 second countdown
                    $ele.prop('disabled', true);
                    let remainingTime = 30;
                    const originalText = $ele.text();

                    const countdownInterval = setInterval(() => {
                        remainingTime--;
                        $ele.text(`Resend OTP in ${remainingTime}s`);

                        if (remainingTime <= 0) {
                            clearInterval(countdownInterval);
                            $ele.prop('disabled', false);
                            $ele.text(originalText);
                        }
                    }, 1000);
                });
            });
        },

        handleOtpSubmit: function (parentForm) {
            const $form = parentForm || $('.generic-form');
            const otpSubmitButton = $form.find('.otp-submit-btn');

            return new Promise((resolve) => {
                otpSubmitButton.off('click').on('click', async (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    formHandler.methods.handleLoader($form, true);

                    // Gather OTP
                    const otpInputs = $form.find('.otp-box input');
                    const otpValue = otpInputs.map((j, input) => $(input).val()).get().join('');

                    // WAIT for verifyOtp to finish
                    const isVerified = await formHandler.methods.verifyOtp(otpValue, $form);

                    if(!isVerified)
                        formHandler.methods.handleLoader($form, false, false);

                    resolve(isVerified);
                });
            });
        },

        otpHandlers: function () {
            $('.generic-form').each((idx, form) => {

                const $form = $(form);
                const hiddenOtp = $form.find('.otp-hidden');
                const inputs = $form.find('.otp-box input');

                if (!inputs.length || !hiddenOtp.length) return;

                let userHasTyped = false;

                // Remove old listeners
                inputs.off('input keydown paste beforeinput focus click touchstart');
                hiddenOtp.off('input');

                hiddenOtp.on('input', function () {
                    let otp = this.value.replace(/\D/g, '').substring(0, inputs.length);
                    if (!otp) return;

                    inputs.val('');
                    for (let i = 0; i < otp.length; i++) {
                        inputs.eq(i).val(otp[i]);
                    }

                    hiddenOtp.blur();

                    const last = inputs.eq(otp.length - 1);

                    last.focus();
                    if (otp.length == 1) {
                        inputs.eq(1).focus();
                    }
                });

                inputs.on('input', function () {
                    userHasTyped = true;
                    let val = this.value.replace(/\D/g, '');
                    this.value = val;

                    const index = inputs.index(this);
                    if (val && index < inputs.length - 1) {
                        inputs.eq(index + 1).focus();
                    }
                    if(index === 0 && val == ""){
                        userHasTyped = false;
                    }
                });

                inputs.on('keydown', function (e) {
                    if (e.key === 'Backspace') {
                        const index = inputs.index(this);
                        if (!this.value && index > 0) {
                            inputs.eq(index - 1).focus();
                            if(index==1){
                                userHasTyped = false;
                            }
                        }
                    }
                });

                // The paste event itself is not cancelled (so paste is not
                // "blocked"); the browser's own insertion is cancelled here in
                // beforeinput and the paste handler spreads the digits across the boxes.
                inputs.on('beforeinput', function (e) {
                    if ((e.originalEvent || e).inputType === 'insertFromPaste') {
                        e.preventDefault();
                    }
                });

                inputs.on('paste', function (e) {
                    const clipboardData = (e.originalEvent || e).clipboardData;
                    if (!clipboardData) return;
                    let paste = clipboardData.getData('text');
                    paste = paste.replace(/\D/g, '').substring(0, inputs.length);
                    if (!paste) return;

                    inputs.val('');
                    for (let i = 0; i < paste.length; i++) {
                        inputs.eq(i).val(paste[i]);
                    }

                    const last = inputs.eq(paste.length - 1);
                    last.focus();
                });

                inputs.eq(0).on('click touchstart', function () {
                    if ((this.value=="" || this.value==" " || this.value==undefined || this.value==null) && !userHasTyped) {
                        hiddenOtp.val('');      // clear hidden OTP
                        hiddenOtp.focus();      // trigger mobile OTP
                    }
                });

            });
        },


        maskMobile: function (number) {
            if (!number || number.length < 4) return number;

            const firstTwo = number.slice(0, 2);
            const lastTwo = number.slice(-2);
            const middleMasked = '*'.repeat(number.length - 4);

            return firstTwo + middleMasked + lastTwo;
        },
        init: function () {
            if($('.generic-form').length){
                formHandler.methods.generateInputIds();
                formHandler.methods.handleEmptyField();
                formHandler.methods.handleEmptyDropdown();
                formHandler.methods.removeTextCenterFromTabs();
                // formHandler.methods.handleDateInput();
                formHandler.methods.handleSubmit();
                // formHandler.methods.validateInput();
                formHandler.methods.backToForm();
                formHandler.methods.calculateAge();
                //                formHandler.methods.checkAnnualIncome();
                formHandler.methods.customizeSelectField();
                formHandler.methods.handleFYAYAutoFill();
                formHandler.methods.addCountryDropdown();
                formHandler.methods.makeAPIRequestForRetialPolicyGroupAsia();
                formHandler.methods.handleResendOtp();
                formHandler.methods.otpHandlers();

                const minimumAge = $('.generic-form-dob').data('minage');
                const today = new Date();
                let minAge = 18;
                const servletID = $('.generic-form__container').find('.generic-form__frame').data('servlet-id');
                if(servletID === 'registerComplaint'){
                    minAge = 0;
                }
                const initialDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());

                formHandler.variables.dobDatepicker = new AirDatepicker('.generic-form-dob', {
                    // Displayed to the user as dd/mm/yyyy. The real value
                    // every downstream consumer needs (yyyy-MM-dd) is kept
                    // in data-iso-value on this same input, set below —
                    // read it via formHandler.methods.getDobIso() instead
                    // of .val() wherever the actual date is needed.
                    dateFormat: 'dd-MM-yyyy',
                    isMobile: window.matchMedia("(max-width: 768px)").matches,
                    maxDate: $('.generic-form-dob').prop('max'),
                    autoClose: true,
                    startDate: initialDate,
                    locale: localEn,
                    onSelect({ date }) {
                        if (date) {
                            const dobInput = $('.generic-form-dob');
                            const pad = (n) => n.toString().padStart(2, '0');
                            const isoValue = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
                            dobInput.attr('data-iso-value', isoValue);
                            dobInput.trigger('change');

                            const today = new Date();
                            const selectedDate = new Date(date);
                            const yearsDifference = today.getFullYear() - selectedDate.getFullYear();
                            const isBeforeBirthday = (
                                today.getMonth() < selectedDate.getMonth() ||
                                (today.getMonth() === selectedDate.getMonth() && today.getDate() < selectedDate.getDate())
                            );
                            const age = isBeforeBirthday ? yearsDifference - 1 : yearsDifference;
                            $('.generic-form__group--age').text(`${age} years`).removeClass('text-red-300').addClass('text-blue-400');
                            $('.age-display').text(`Age: ${age}`);
                            $('.generic-form-dob').removeClass('border-red-300');
                            if(age <= minimumAge){
                                $('.generic-form-dob').closest('.generic-form__group').find('.empty-error').addClass('opacity-0');
                                $('.generic-form-dob').closest('.generic-form__group').find('.invalid-error').removeClass('opacity-0');
                                $('.generic-form-dob').addClass('border-red-300');
                            }
                            else{
                                $('.generic-form__group--error').addClass('opacity-0');
                                $('.generic-form-dob').removeClass('border-red-300');
                            }
                        }
                    }
                });

                // Escape key to close any open genericForm response modal (WCAG 2.1.2)
                $(document).on('keydown.genericFormA11y', function(e) {
                    if (e.key === 'Escape') {
                        var modalSelectors = [
                            '.inside-body-haveThankyou',
                            '.inside-body-dstThankyou',
                            '.inside-body-tdsThankyou',
                            '.inside-body-register-complaint'
                        ];
                        for (var i = 0; i < modalSelectors.length; i++) {
                            var $modal = $('body').find(modalSelectors[i]).not('.d-none');
                            if ($modal.length) {
                                e.preventDefault();
                                $modal.find('[class*="__close--icon"], [class*="__close"]').first().trigger('click');
                                releaseFocus();
                                break;
                            }
                        }
                    }
                });

                $('.generic-form').each((idx, ele) => {
                    formHandler.methods.closeResponse(ele);
                    formHandler.methods.closeDSTResponse(ele);
                    formHandler.methods.closeDigitalResponse(ele);
                    formHandler.methods.closeRequestComplaint(ele);
                    formHandler.methods.closeHaveQuestionResponse(ele);
                    formHandler.methods.handleFileHandler(ele);
                    formHandler.methods.closeRetailGroupResponse(ele);
                    formHandler.methods.validateInput();

                    const container = $('.generic-form__frame');
                    const isSameLine = container.data('dobsameline') === true || container.data('dobsameline') === "true";

                    if (isSameLine && window.innerWidth <= 768) {

                        const dobField = $('.dob-field');
                        const incomeField = $('.income-field');

                        if (dobField.length && incomeField.length) {

                            if (!$('.generic-form__dob-income-wrapper').length) {

                                const wrapper = $('<div class="generic-form__dob-income-wrapper"></div>');

                                dobField.before(wrapper);
                                wrapper.append(dobField);
                                wrapper.append(incomeField);

                            }
                        }
                    }
                });
            }
        }

    }
};

$(() => {
    formHandler.methods.init();
});

$(function () {
    formHandler.methods.ctaButtonClickHandler();
});

export default formHandler;
